module.exports = __webpack_public_path__ + "static/media/vessel_stopped.434eb3dc.svg";